/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-undef */

/**
* MIND CONTACT FORM SETTINGS PAGE
*
* @since      1.0
* @package    Mindfolio
* @subpackage Mind Contact Form
* @author     Webmajstr <info@webmajstr.cz>
* @copyright  Copyright (c) 2021 Webmajstr
* @license    GPL2+
*/

import wms_Field from './wms-field';
import validation_types from './types';

interface WmFormValues {
	name?		: any,
	email?		: any,
	captcha?	: any,
	subject?	: any
}

export default class WM_Subscribe_Form_Public {

	status_on: 	boolean;

	captcha_check: boolean;

	val_regs: validation_types;

	el_cont: HTMLDivElement;

	el_submit: HTMLButtonElement;

	el_status: HTMLDivElement;

	status_message: HTMLSpanElement;

	el_loader: HTMLDivElement;

	err_label: HTMLSpanElement;

	Fields: wms_Field[];

	form_type: string;

	captcha: string;

	contact_ajax_obj: any;


	/**
	 * The array of actions registered with WordPress.
	 * @since    1.0.0
	 */

	constructor( el_wms_container:HTMLDivElement ) {

		// set false for localhost none captcha development. Don't forget to put back to true when going public
		this.captcha_check = true;

		this.contact_ajax_obj = (window as any).contact_ajax_obj;

		console.log('CONTACT AJAX OBJ JE');
		console.log(this.contact_ajax_obj);

		// DATA VALIDATION REGEXPS

		this.val_regs = {}
		this.val_regs.email = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

		this.status_on = false; // check wether the status screen is on

		this.el_cont = el_wms_container;

		this.el_submit = this.el_cont.querySelector('.submit');

		this.el_status = this.el_cont.querySelector ( '.wms-status-cont');

		this.status_message = this.el_status.querySelector ( '.wms-message-span');

		this.el_loader = this.el_status.querySelector('.wms-loader');

		this.form_type = this._get_form_type();

		this.Fields = this.array_instances();

		this.captcha = this.contact_ajax_obj.gpublic;

		this._append_sitekey(); // appends sitekey from wordpress plugin settings to dom element submit

		this.el_submit.addEventListener('click', e => {

			this.form_submit(e);

		});

		this._load_captcha (); //dynamically loads captcha if not loaded from different instance

	}

	/**
	 * Public function Init ()
	 * Loops through the given container element and sets all the necessary HTML Components as variables
	 * @return Void
	 */

	init():void {

		console.log ('INITIALIZING MIND CONTACT FORM');
	
	}


	//  MAIN PARENT SUBMIT METHOD

	form_submit ( e: MouseEvent ):void {

		e.preventDefault ();

		if (this.captcha_check === true) {

			console.log(grecaptcha);

			grecaptcha.ready (() => {

				grecaptcha.execute( this.captcha, { action: 'submit' } ).then ( (/*token: string*/) => {
				
					this.check_and_post();

				});
			});
		}
		else
			this.check_and_post();
	}

	check_and_post ():void {

		new Promise(( resolve, reject ) => {

			this.Fields.forEach ( Field => {
				
				if ( !Field.check ())
					return reject ( 'FAILURE' );
			});
			
			return resolve ( 'success' );

		} ).then (

			() => {

				this.status (this.contact_ajax_obj.loading, 'loading');

				this.data_send ();

			},
			reason => {

				console.log(reason);
			}
		);
		
	}
	
	/**
	 * ARRAY_INSTANCES
	 * Returns an Array of class „Field” Instances.
	 * @since 1.2
	 */
	array_instances ():wms_Field[] {

		const arr_fields:wms_Field[] = [];
		const html_fields = this.el_cont.querySelectorAll('.field');
		
		html_fields.forEach ( html_field  => {

			arr_fields.push ( new wms_Field ( html_field as HTMLDivElement, this.val_regs ));

		});

		return arr_fields;
	}
	data_collect_json ():string {

		const values:WmFormValues = {};

		this.Fields.map( f => {

			values [ f.name as keyof WmFormValues] = f.get_value();

		});

		return (JSON.stringify(values));
	}

	data_send ():void {

		const data = this.data_collect_json();
		
		const request = new XMLHttpRequest();

		const captcha = this.captcha_check ? grecaptcha.getResponse() : false;

		request.open ( 'POST', this.contact_ajax_obj.ajaxurl, true );

		request.setRequestHeader ( 'Content-Type', 'application/x-www-form-urlencoded;' );

		request.onload = () => {

			console.log(request.response);
	
			if (request.status >= 200 && request.status < 400) {

				const resp = JSON.parse(request.response);

				resp.message = resp.message.replace(/\\/g, '');
				console.log ( resp.message );
				this.status ( resp.message, resp.type);
			
			} else {
				this.status ( request.response, 'error');
			}
		};
		request.onerror = () => {
			this.status ( request.response, 'error' );
		};


		const request_data = 'action=wms_subscribe&_ajax_nonce='+this.contact_ajax_obj.nonce+'&form_type='+this.form_type+'&captcha='+captcha+'&data='+data;
		console.log(request_data);
		request.send(request_data);

	}

	escapeHtml(html: string):string {

		const text = document.createTextNode(html);

		const p = document.createElement('p');

		p.appendChild(text);

		return p.innerHTML;

	}

	display_el ( el: HTMLDivElement , display: string):void {

		if( el ){
			el.style.display = display;
		}
		else {
			// error message
		}
	}

	reset_form():void {

		this.clean_status();
		this.hide_status();

		this.Fields.map ( f => {
			f.reset();
			f.empty();
		});
	}
	
	/**
	 * ARRAY_INSTANCES
	 * Handles the frontend communication with user.
	 * @param message string - the message to be displayed
	 * @param type string - type of messsage ('error', 'success', 'loading)
	 * @return void
	 * @since 1.2
	 */
	status ( message: string, type: string ):void {

		this.clean_status();

		if ( !this.status_on ){
			this.show_status();
			this.status_on = true;
		}

		switch ( type ) {

		case 'loading':
			console.log ( message );
			this.display_el ( this.el_loader, 'block' );
			this.print_message ( message, 'info' );
			break;
		case 'error':
			this.print_message ( message, 'error' );
			this.show_reset_button();
			break;
		default:
			this.print_message (message, type);
			break;
		}
	}

	show_reset_button ():void {

		console.log('show reset button here');
	}

	/**
	 * PRINT_MESSAGE
	 * Handles the display of the messages in both cases success and error.
	 * @param m string - the message to be displayed
	 * @param t string - type of messsage ('error', 'success' )
	 * @return void
	 * @since 1.2
	 */
	print_message ( m: string, t: string ):void {

		const success_icon = '<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>';

		switch ( t ) {
		case 'error':
			t = 'has-text-danger';
			break;
		case 'success':
			t = 'has-text-success';
			m = success_icon+''+m;
		}

		this.status_message.innerHTML = m;
		this.status_message.classList.add(t);
	} 

	clean_status ():void {

		this.display_el ( this.el_loader, 'none' );
		this.status_message.innerHTML = '';
		this.status_message.setAttribute ( 'class', '' );

	}
	show_status ():void {

		//TODO add class to appear;
		this.el_status.style.display = 'flex';

	}
	hide_status ():void {

		this.el_status.style.display = 'none';

	}

	/**
	 * LOAD_CAPTCHA
	 * checks if gcaptcha is present on page and if not loads the google script to render it
	 * @since 1.3
	 * @return void
	 */
	_load_captcha ():void {
		if(!this.contact_ajax_obj.captcha){

			this.contact_ajax_obj.captcha = true;

			const script:HTMLScriptElement = document.createElement('script');
			script.onload = function () { 
				console.log('captcha loaded');
			};
			script.src = this.contact_ajax_obj.captcha_url;

			document.head.appendChild(script); //or something of the likes

		}
	}

	/**
	 * _GET_FORM_TYPE
	 * Grabs the type of form stored in wmsType attribute on wrapper object of form (.wms-form-container).
	 * @since 1.3
	 * @return string - the type of the form
	 */
	_get_form_type ():string {

		return this.el_cont.getAttribute('wmstype');

	}


	/**
	 * _append_sitekey
	 * Assigns data-sitekey from wordpress plugin settings
	 * @since 1.4
	 * @todo completely rework for guttenberg settings
	 * @return boolean true if got false if not provided
	 */
	private _append_sitekey():boolean {

		const k = this.contact_ajax_obj.gpublic;

		if (k ) {
			this.el_submit.setAttribute('data-sitekey', k);
			return true;
		}

		return false;
	}
}